import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ID, withCodes } from 'app/blocks/common/codes';
import showDialog from 'app/blocks/common/jsx/dialogModal';
import * as MiddlewareArticleAssignment from 'app/blocks/middleware/article-assignment';
import * as middlewareSearch from 'app/blocks/middleware/search';
import MiniSearch from 'app/blocks/mini-search/MiniSearch';
import MiniSearchItem from 'app/blocks/mini-search/MiniSearchItem';
import { MainTitle } from 'app/blocks/titles/titles';
import AdvanceSearchButtons from 'app/pages/search/advance-search-buttons/AdvanceSearchButtons';
import { navigate, goBack } from 'app/route/history';
import { Input2 } from 'app/ui/form/inputs';
import RadioButton from 'app/ui/form/RadioButton';
import MissingArticleSubmitSuccess from './MissingArticleSubmitSuccess';

import './MissingArticleDetails.scss';

function MissingArticleDetails(props) {
    const { codes } = props;
    const search = codes.SEARCH_CODES.SEARCH.MISSING_ARTICLE;
    const inputType = {
        correspondingAuthor: 'correspondingAuthor',
        doi: 'articleDoi',
        journal: 'journalId',
        refCode: 'articleManuscriptId',
        title: 'articleTitle',
    };

    const isRexFlow = !!useParams().system;

    const [journalSearch, setJournalSearch] = useState(null);
    const [journalApiData, setJournalApiData] = useState(null);

    const [formData, setFormData] = useState({
        articleDoi: '',
        articleManuscriptId: '',
        articleTitle: '',
        correspondingAuthor: null,
        journalId: null,
    });
    const [canSubmitForm, setCanSubmitForm] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const isNotEmpty = value => {
        return value !== null && value.length !== 0;
    };

    const handleEnableFormSubmit = data => {
        if (isNotEmpty(data.journalId) && isNotEmpty(data.articleTitle) && data.correspondingAuthor != null) {
            setCanSubmitForm(true);
        } else {
            setCanSubmitForm(false);
        }
    };

    useEffect(() => {
        handleEnableFormSubmit(formData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    const onChangeInput = (type, value) => {
        if (type) {
            setFormData({
                ...formData,
                ...{
                    [type]: value,
                },
            });
        }
    };

    const onBackToArticleSearch = () => {
        goBack();
    };

    const onBackToDashboard = () => {
        navigate('/dashboard');
    };

    const handleSearch = async query => {
        setJournalSearch(query);

        if (query === '') {
            onChangeInput(inputType.journal, null);
        }

        let data = [];
        if ((query || '').trim()) {
            data = (await middlewareSearch.journalOnlySearch({ title: query }, { offset: 0, size: 5 })).items;
            setJournalApiData(data);
        } else {
            setJournalApiData(data);
        }
    };

    const handleSearchListClick = query => {
        setJournalSearch(query);
    };

    const handleOnSubmit = async () => {
        const handler = isRexFlow
            ? MiddlewareArticleAssignment.notifyAdminMissingArticleRexFlow
            : MiddlewareArticleAssignment.notifyAdminMissingArticle;

        try {
            await handler(formData);
            setSubmitted(true);
        } catch (error) {
            showDialog.error(error);
        }
    };

    return (
        <main className="col-lg-8 offset-lg-2" id="as-main-content-7f3d9e2a">
            <div className="MissingArticleDetails-Header">
                <MainTitle>{search.title}</MainTitle>
            </div>
            {submitted && <MissingArticleSubmitSuccess />}

            {!submitted && (
                <div className="MissingArticleDetails-FormContent" data-seleniumid="missing-article-details-page">
                    <p>{search.description}</p>
                    <div className="clearfix" />
                    <div className="MissingArticleDetails-Fields">
                        <div className="fields">
                            <label>
                                {search.journal} <span className="required">{search.required_label}</span>
                            </label>
                            <MiniSearch
                                defaultValue={journalSearch}
                                onInput={handleSearch}
                                searchResults={journalApiData}
                                seleniumId="journalSearch-combobox-input"
                                withSub
                            >
                                {journalApiData &&
                                    journalApiData.map(journal => (
                                        <div key={journal.id}>
                                            <MiniSearchItem dataSeleniumId={`journal-${journal.id}`}>
                                                <button
                                                    onClick={() => {
                                                        onChangeInput(inputType.journal, journal.id);
                                                        handleSearchListClick(journal.doc.title);
                                                    }}
                                                    type="button"
                                                >
                                                    {journal.doc.title}
                                                </button>
                                            </MiniSearchItem>
                                        </div>
                                    ))}
                            </MiniSearch>
                        </div>
                        <div className="fields">
                            <label htmlFor="missing-article-article-title">
                                {search.article} <span className="required">{search.required_label}</span>
                            </label>
                            <Input2
                                data-seleniumid="missing-article-article-title"
                                id="missing-article-article-title"
                                onChange={value => onChangeInput(inputType.title, value)}
                            />
                        </div>
                        <div className="fields">
                            <label htmlFor="missing-article-editorial-ref-code">{search.ref}</label>
                            <Input2
                                data-seleniumid="missing-article-editorial-ref-code"
                                id="missing-article-editorial-ref-code"
                                onChange={value => onChangeInput(inputType.refCode, value)}
                            />
                        </div>
                        {!isRexFlow && (
                            <div className="fields">
                                <label htmlFor="missing-article-doi-input">{search.doi}</label>
                                <Input2
                                    data-seleniumid="missing-article-doi-input"
                                    id="search-advanced-search-doi-input"
                                    onChange={value => onChangeInput(inputType.doi, value)}
                                />
                            </div>
                        )}
                        <div className="fields">
                            <label>
                                {search.author_hint} <span className="required bold">{search.required_label}</span>
                            </label>
                            <div className="AssignArticleByIdTxtSeparate">
                                <RadioButton
                                    checked={formData.correspondingAuthor === true}
                                    data-seleniumid="assign-article_by-id-radio-corr-author"
                                    id="missing-article-article-corr-author"
                                    label={isRexFlow ? search.subm_author : search.corr_author}
                                    name="missing-article-article-radio"
                                    onChange={() => {
                                        onChangeInput(inputType.correspondingAuthor, true);
                                    }}
                                    style={{ display: 'inline-flex', marginRight: '30px' }}
                                    value
                                />
                            </div>
                            <div className="AssignArticleByIdTxtSeparate">
                                <RadioButton
                                    checked={formData.correspondingAuthor === false}
                                    data-seleniumid="assign-article_by-id-radio-co-author"
                                    id="missing-article-article-co-author"
                                    label={search.co_author}
                                    name="missing-article-article-radio"
                                    onChange={() => {
                                        onChangeInput(inputType.correspondingAuthor, false);
                                    }}
                                    style={{ display: 'inline-flex' }}
                                    value={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!submitted && (
                <AdvanceSearchButtons
                    disableOnNext={!canSubmitForm}
                    nextButtonText={search.btn_next}
                    onNext={handleOnSubmit}
                    onPrevious={onBackToArticleSearch}
                    previousBtnText={search.btn_prev}
                />
            )}
            {submitted && (
                <AdvanceSearchButtons hideNext onPrevious={onBackToDashboard} previousBtnText={search.btn_board} />
            )}
        </main>
    );
}

export default withCodes(React.memo(MissingArticleDetails), ID.SEARCH_CODES);
